import React from "react";

function ProductCard({ accent, product, onClick }) {
  const accentClasses = {
    orange: "border-orange-400 text-orange-500",
    blue: "border-sky-400 text-sky-500",
    green: "border-emerald-400 text-emerald-500",
    purple: "border-purple-400 text-purple-500",
  };

  const accentClass = accentClasses[accent || "orange"];
  const price = product?.price ? Number(product.price).toFixed(2) : "0.00";

  // Static visual comparison values to match Figma
  const comparison = [
    { store: "Tesco", price: "1.98", color: "bg-blue-500" },
    { store: "Morrisons", price: "1.80", color: "bg-emerald-500" },
    { store: "Asda", price: "1.91", color: "bg-sky-500" },
    { store: "Sainsbury's", price: "1.75", color: "bg-orange-500" },
  ];

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex flex-col rounded-[18px] border border-slate-200 bg-white text-left shadow-sm transition-shadow hover:shadow-md"
    >
      <div className="flex-1 p-4">
        {/* Pack size pill at top-left */}
        <div className="mb-2 flex justify-start">
          <span className="inline-flex rounded-full bg-orange-50 px-2 py-0.5 text-[10px] font-semibold text-orange-600">
            {product?.packsize || "200g"}
          </span>
        </div>

        {/* Image */}
        <div className="mb-4 flex h-28 items-center justify-center rounded-xl bg-slate-100">
          {product?.images?.[0] ? (
            <img
              src={product.images[0]}
              alt={product.title || product.sku}
              className="h-full object-contain"
            />
          ) : (
            <span className="text-xs text-slate-400">No Image</span>
          )}
        </div>

        {/* Name */}
        <p className="text-sm font-semibold text-slate-900 line-clamp-2">
          {product?.title || product?.sku || "Easy Wring Turbo"}
        </p>

        {/* Best price pill */}
        <p className="mt-2 inline-flex rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-semibold text-emerald-600">
          Best Price £{price || "1.75"}
        </p>

        {/* Comparison bar: prices row + colour bars + store labels */}
        <div className="mt-2 space-y-1 text-[10px]">
          {/* Prices row */}
          <div className="flex justify-between font-semibold text-slate-900">
            {comparison.map((item) => (
              <span key={item.store}>£{item.price}</span>
            ))}
          </div>

          {/* Colour columns */}
          <div className="flex items-end justify-between gap-1">
            {comparison.map((item, idx) => (
              <div key={item.store} className="flex-1">
                <div
                  className={`mx-auto w-full rounded-t-md ${item.color} ${
                    // small height variations to mimic chart feel
                    idx === 1 ? "h-5" : idx === 3 ? "h-6" : "h-4"
                  }`}
                />
              </div>
            ))}
          </div>

          {/* Store labels row */}
          <div className="flex justify-between text-[9px] text-slate-600">
            {comparison.map((item) => (
              <span key={item.store}>{item.store}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="px-4 pb-4">
        <button
          type="button"
          className={`w-full rounded-full border py-2.5 text-xs font-semibold ${accentClass}`}
        >
          Add →
        </button>
      </div>
    </button>
  );
}

export default ProductCard;